import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "survey_question" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "required-item"
}
const _hoisted_4 = {
  key: 0,
  class: "helper-text"
}
const _hoisted_5 = { class: "survey_responses" }

export interface Props {
  errors?: string[];
  name: string;
  label?: string;
  helpText?: string;
  labelExtraClasses?: string;
  required?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TandemInputWrapper',
  props: {
    errors: {},
    name: {},
    label: {},
    helpText: {},
    labelExtraClasses: {},
    required: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["survey_prompt", _ctx.labelExtraClasses]),
      for: _ctx.name
    }, [
      _renderSlot(_ctx.$slots, "label", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true),
      (_ctx.errors)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "survey_error",
              role: "alert",
              key: error
            }, _toDisplayString(error), 1))
          }), 128))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    (_ctx.helpText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.helpText), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})